import React from 'react';
export function Eyebrow({
  children,
  danger = false
}: {
  children: React.ReactNode;
  danger?: boolean;
}) {
  return <p className={`mb-3 text-center text-[11px] font-extrabold uppercase tracking-[.16em] md:text-sm ${danger ? 'text-red-600' : 'text-sky-700'}`} data-id="element-385" data-mp="2i6ntz6tte4yu">
      {children}
    </p>;
}
export function SectionTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="mx-auto max-w-3xl text-center text-2xl font-black uppercase leading-tight text-slate-900 md:text-4xl" data-id="element-386" data-mp="35u5qtgrxrt8o">
      {children}
    </h2>;
}
export function SectionLead({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="mx-auto mt-3 max-w-2xl text-center text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-387" data-mp="3euu4ubhbxtlk">
      {children}
    </p>;
}
export function Mark({
  children
}: {
  children: React.ReactNode;
}) {
  return <mark className="rounded-sm bg-yellow-200 px-1 text-slate-900 [box-decoration-break:clone]" data-id="element-388" data-mp="1gg0qifmbe5gr">
      {children}
    </mark>;
}